import { toast } from 'react-toastify';

const showToast = (type, message) => {
  // Check if dark theme is active
  const isDarkTheme = document.documentElement.classList.contains('theme-dark');
  
  const baseStyle = isDarkTheme 
    ? {
        fontSize: '14px',
        fontWeight: '500',
        backgroundColor: '#1a1428',
        backdropFilter: 'blur(8px)',
        color: '#ffffff',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
        borderRadius: '8px',
        padding: '12px 16px'
      }
    : {
        fontSize: '14px',
        fontWeight: '500',
        backgroundColor: '#ffffff',
        backdropFilter: 'blur(8px)',
        color: '#1a1428',
        border: '1px solid #e5e7eb',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
        borderRadius: '8px',
        padding: '12px 16px'
      };

  switch (type) {
    case 'success':
      toast.success(message, {
        style: baseStyle
      });
      break;
    case 'error':
      toast.error(message, {
        style: baseStyle
      });
      break;
    case 'info':
      toast.info(message, {
        style: baseStyle
      });
      break;
    case 'warning':
      toast.warning(message, {
        style: baseStyle
      });
      break;
    case 'caution':
      toast.warning(message, {
        style: baseStyle,
      });
      break;
    default:
      toast(message, {
        style: baseStyle
      });
      break;
  }
};

export default showToast;